"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_5443123a{position:relative;cursor:default}.dragMask_5443123a{position:absolute;background:rgba(255,0,0,0);left:0;top:0;right:0;bottom:0}@media screen and (-ms-high-contrast: active){.dragMask_5443123a{background:none}}.box_5443123a{position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid " }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";pointer-events:none;z-index:10}@media screen and (-ms-high-contrast: active){.box_5443123a{border-color:Highlight}}.boxFill_5443123a{position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d7" }, { "rawString": ";opacity:.1;left:0;top:0;right:0;bottom:0}@media screen and (-ms-high-contrast: active){.boxFill_5443123a{background:none}}\n" }]);
exports.root = "root_5443123a";
exports.dragMask = "dragMask_5443123a";
exports.box = "box_5443123a";
exports.boxFill = "boxFill_5443123a";
//# sourceMappingURL=MarqueeSelection.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/MarqueeSelection/MarqueeSelection.scss.js
// module id = 385
// module chunks = 0